import $ from 'jquery';
import throttle from 'lodash.throttle';
import 'url-polyfill';
import 'objectFitPolyfill';

window.$ = window.jQuery = $;

$(function() {
    // ハンバーガーボタンでメニューを開く
    $('[data-js="hamburger-button"]').on('click', function() {
        $(this).toggleClass('open');
        $('[data-js="sliding-menu"]').toggleClass('open');
    });

    // ページロード時にグローバルナビの状態を調整
    refreshGlobalNavState();

    // スクロールしたらグローバルナビの状態を調整
    $(document).on('scroll', throttle(refreshGlobalNavState, 100));

    // ページロード時にハッシュがあったら、その位置へスクロール
    if (window.location.hash) {
        scrollToHash();
    }

    // アンカーリンクをクリックしたときの処理
    $('a[href*="#"]').on('click', handleHashLinkClick);

    // 言語切替リンクをクリックした時の処理
    $('[data-js-switch-locale]').on('click', handleLocaleSwitch);

    // 縦スクロール可能を示すバーをアニメート
    if ($('[data-js="scrollable-indicator"]').length) {
      animateScrollableIndicator();
    }

    // フォームをjsで処理
    if ($('[data-js="contact-form"]').length) {
      rigContactForm();
    }

    // Googleマップをロード
    if ($('[data-js="company-map"]').length) {
      loadGoogleMap($('[data-js="company-map"]')[0], 35.6695488, 139.7639061, 18);
    }
});

// スクロール位置に応じてグローバルナビの状態を調整
function refreshGlobalNavState() {
  let thres = 0;
  if ($('[data-js="key-visual"]').length) {
    thres = $('[data-js="key-visual"]').height() * 0.5;
  }

  if ($(document).scrollTop() >= thres) {
      $('[data-js="global-nav"]').addClass('after-scroll');
  } else {
      $('[data-js="global-nav"]').removeClass('after-scroll');
  }
}

// ハッシュ付きリンクをクリックしたときの挙動
function handleHashLinkClick(event) {
  let target = new URL(this.href);
  let current = new URL(window.location.href);
  let targetHash = target.hash;

  // hash以外は同じURLか？
  current.hash = target.hash = '';
  if (target.toString() == current.toString()) {
    scrollToHash(targetHash);
    window.location.hash = targetHash;
    event.preventDefault();
    return false;
  }
}

// ロケーションハッシュの位置へスムーズスクロールする
function scrollToHash(hash = window.location.hash) {
  let $target = $(hash);
  let top = $target.offset() ? $target.offset().top : 0;
  if (top > 0) {
    top -= $('[data-js="global-nav"]').height();
  };
  $('html, body').animate({ scrollTop: top }, 250);

  // グローバルナビを開いていたら閉じる
  $('[data-js="hamburger-button"]').removeClass('open');
  $('[data-js="sliding-menu"]').removeClass('open');
}

// 言語切替リンクをクリックした時の処理
function handleLocaleSwitch(event) {
  let toLocale = $(event.target).data("js-switch-locale");
  let url = new URL(window.location);
  url.pathname = url.pathname.replace(/^\/[\w-]+\//, `/${toLocale}/`);
  window.location = url.toString();
  event.preventDefault();
}

// 縦スクロール可能を示すバーをアニメート
function animateScrollableIndicator() {
  let duration = 1000;
  let wait = 750;

  let $seg1 = $('[data-js="scrollable-indicator"] .segment1');
  let $seg2 = $('[data-js="scrollable-indicator"] .segment2');

  let extend = function() {
    $seg1.css({ height: 0, top: 0 });
    $seg2.css({ height: 0, top: 100 });

    $({ h: 0 }).animate({ h: 150 }, {
      duration: duration,
      progress: function() {
        $seg1.css({ height: Math.min(this.h, 100) });
        $seg2.css({ height: Math.max(0, this.h-100)} );
      },
      complete: function() {
        setTimeout(shrink, wait);
      },
    });
  }

  let shrink = function() {
    $seg1.css({ height: 100, top: 0 });
    $seg2.css({ height: 50, top: 100 });

    $({ h: 150 }).animate({ h: 0 }, {
      duration: duration,
      progress: function() {
        $seg1.css({ height: Math.min(this.h, this.h-50), top: 100-(Math.min(this.h, this.h-50)), });
        $seg2.css({ height: Math.min(50, this.h), top: 150-(Math.min(50, this.h)), });
      },
      complete: function() {
        setTimeout(extend, wait);
      },
    });
  }

  extend();
}

// コンタクトフォームの処理
function rigContactForm(event) {
  let $form = $('[data-js="contact-form"]');

  $form.find('input, textarea').on('change', function() {
    this.setCustomValidity('');
    this.reportValidity();
  });

  $form.on('submit', function(event) {
    event.preventDefault();

    $form.find('button[type="submit"]').attr('disabled', true);

    $.post({
        url: $form.attr("action"),
        contentType: false,
        data: new FormData($form[0]),
        processData: false,
        crossDomain: true,
    }).done((data, status, jqXHR) => {
        window.location.href = window.location.href.replace(/\/[^/&?]+$/, '/thanks.html');
    }).fail((jqXHR, status, error) => {
        let errors = jqXHR.responseJSON;
        if (errors) {
            Object.keys(errors).forEach(field => {
                $form.find(`[name="${field}"]`)[0].setCustomValidity(errors[field].join("\n"));
                $form[0].reportValidity();
            });
        }
    }).always(() => {
      $form.find('button[type="submit"]').attr('disabled', false);
    });
  });
}

// Google Mapをロード
function loadGoogleMap(elem, lat, lng, zoom) {
  let latlng = new google.maps.LatLng(lat, lng);

  let map = new google.maps.Map(elem, {
    zoom: zoom,
    center: latlng,
    mapTypeControl: false,
    zoomControl: false,
    fullscreenControl: false,
    streetViewControl: false
  });

  let icon = {
    url: "/assets/img/mapmarker.svg",
    scaledSize: new google.maps.Size(48, 48),
  };
  
  let marker = new google.maps.Marker({position: latlng, map, icon});

  let mapStyle = [
    {
      featureType: 'all',
      stylers: [ { saturation: -100 }, { lightness: 35 } ]
    },
    {
      featureType: 'landscape.man_made',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'poi',
      stylers: [{ visibility: 'simplified' }],
    },
    {
      featureType: 'poi',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'simplified' }, { lightness: 5 }]
    },
    {
      featureType: 'road',
      stylers: [{ visibility: 'simplified' }],
    },
    {
      featureType: 'road',
      elementType: 'labels.text',
      stylers: [{ visibility: 'simplified'}, { lightness: 70 }],
    },
    {
      featureType: 'transit',
      stylers: [{ visibility: 'simplified' }],
    }
  ];

  let mapType = new google.maps.StyledMapType(mapStyle);
  map.mapTypes.set('GrayScaleMap', mapType);
  map.setMapTypeId('GrayScaleMap');
};
